const o = ["#5E63E5"], _ = [...o, "#D33CE7"], t = [..._, "#C6012F"], c = [..._, "#8027FC", t[2]];
export {
  o as POI_1_TA1,
  _ as POI_1_TA2,
  t as POI_1_TA3,
  c as POI_1_TA4
};
//# sourceMappingURL=index.es5714.js.map
